import useSWR from 'swr';
import { fetchAgentProfile } from './fetchAgentProfile';

export const useAgentProfile = ({
  userId,
  teamId,
  skip,
  loadPreferences = false,
  keepPreviousData = false,
}: {
  userId?: string | null;
  teamId?: string | null;
  skip?: boolean;
  /** See {@link fetchAgentProfile} — opt in only for own/primary agents. */
  loadPreferences?: boolean;
  /**
   * Smooths flicker while a new profile loads. Display-only — consumers that
   * diff the profile must not opt in, or they compare against stale data.
   */
  keepPreviousData?: boolean;
}) => {
  const { data, isLoading, error } = useSWR(
    !skip && userId && teamId
      ? (['agent-profile', userId, teamId, loadPreferences] as const)
      : null,
    ([, memberUserId, memberTeamId, withPreferences]) =>
      fetchAgentProfile(memberUserId, memberTeamId, {
        loadPreferences: withPreferences,
      }),
    { keepPreviousData },
  );

  return {
    data,
    loading: isLoading,
    error,
  };
};
